import { useEffect, useState } from "react";

/** A clock that ticks once a minute, so relative times in the table age together without re-rendering per second. */
export function useMinuteClock(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(timer);
  }, []);
  return now;
}
